import { ReactComponent as BtnPrevious } from '../../Assets/img/Previous1.svg';
import { ReactComponent as FirstPage } from '../../Assets/img/Previousfirst.svg';
import { ReactComponent as FirstPageHover } from '../../Assets/img/PreviousfirstHover.svg';
import { ReactComponent as BtnPreviousHover } from '../../Assets/img/PreviousHover1.svg';
import { ReactComponent as LastPage } from '../../Assets/img/Previouslast.svg';
import { ReactComponent as LastPageHover } from '../../Assets/img/PreviouslastHover.svg';
import { ReactComponent as BtnNext } from '../../Assets/img/Previousnext.svg';
import { ReactComponent as BtnNextHover } from '../../Assets/img/PreviousnextHover.svg';

function Pagination(props) {
    const pages = [5, 10, 20, 50, 100];

    return (
        <div className="pagination-container">
            <div className="pagination-input-container">
                <select className="pagination-select" value={props.perPage} onChange={props.changePerPage} >
                    {pages.map((page) => (
                        <option value={page} className="pagination-record-perpage-options">{page}</option>
                    ))}
                </select>
            </div >
            <div className="pagination-records-text">
                <span>  Records / Page </span>
            </div>
            <div style={{ borderLeft: "1px solid #0000001F", marginLeft: "1.5%" }}></div>
            <div className="pagination-icon-container">
                <div className="pagination-icon" onClick={props.onFirstClick} style={{ marginLeft: "8px" }}>
                    <FirstPage />
                    <FirstPageHover className="hover-icon" />
                </div>
                <div className="pagination-icon" onClick={props.onPreviousClick} >
                    <BtnPrevious />
                    <BtnPreviousHover className="hover-icon" />
                </div>
                <span style={{ margin: "0 10px 0 10px" }}>Page <strong>{props.totalData == 0 ? '0' : props.currentPage} </strong> of {props.totalPage}</span>
                <div className="pagination-icon" onClick={props.onNextClick} >
                    <BtnNext />
                    <BtnNextHover className="hover-icon" />
                </div>
                <div className="pagination-icon" onClick={props.onLastClick} >
                    <LastPage />
                    <LastPageHover className="hover-icon" />
                </div>
            </div>
        </div>
    );
}

export default Pagination;